module.exports = __webpack_public_path__ + "img/Menu-10.b1841949.png";